import { useState } from "react";
import { Button, Alert } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";

function CertificateDownloadButton() {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleDownload = async () => {
    setLoading(true);
    setError(null);

    try {
      const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
      const res = await fetch(`${API_URL}/api/v1/certificate`, {
        method: "GET",
        credentials: "include",
      });

      if (!res.ok) {
        throw new Error("Failed to fetch certificate");
      }

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `CTGWeb2_Certificate.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {error && <Alert variant="danger">{error}</Alert>}
      <Button
        onClick={handleDownload}
        variant="primary"
        className="app-button"
        disabled={loading}
      >
        {loading ? "Downloading..." : "Download Certificate"}
      </Button>
    </div>
  );
};

export default CertificateDownloadButton;

